import { useRootStore } from '~/store/root'

export default defineNuxtRouteMiddleware((to) => {
  const { $pinia } = useNuxtApp()
  const { authUser, isEmbedded } = useRootStore($pinia)
  const isEmbeddedUser = authUser?.isEmbedded && isEmbedded
  const isEmbeddedPath = /\/embedded(\/|$)/.exec(to.path)

  if ((!isEmbeddedUser && isEmbeddedPath) || (isEmbeddedUser && !isEmbeddedPath)) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page not found.',
      data: {
        isEmbedded,
      },
      fatal: true
    })
  }
})
